import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { ChecklistTask, Field } from "../../../api/types/objectTypes";

interface Props {
  objectType: string;
  objectId: string;
  hasPermissionsToManageObjectData: boolean;
  editableChecklistTaskFields: Field[];
  onChecklistTasksUpdate: (updatedTasks: ChecklistTask[]) => void;
  onApprovalActionExecuted: () => void;
  isSavingTaskId: string | undefined;
  setSavingTaskId: (taskId: string | undefined) => void;
}

const ObjectTasksContext = createContext<Props | undefined>(undefined);

export const ObjectTasksContextProvider = ({ children, ...contextValue }: PropsWithChildren<Props>) => {
  return <ObjectTasksContext value={contextValue}>{children}</ObjectTasksContext>;
};

export default ObjectTasksContext;
